export default "__VITE_ASSET__10b8274f__"